import { CARD, DELIVERY, GIFT_ADDS } from "~/utils/shopify";
import { CustomAttributs } from "~/constants/custom-attributs";
import { nanoid } from "nanoid";
import dayjs from 'dayjs';
import { getCookieValueByName } from "~/utils/cookie";
export default {
  methods: {
    parseCartItemsToLineItems(cartItems: any) {
      try {
        const lineItems = { bouquest: {} };
        for (const cartItem of Object.values(cartItems)) {
          this.processAllItems(cartItem, lineItems.bouquest);
        }
        return lineItems;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    processAllItems(cartItem: any, bouquest: any) {
      const { id } = cartItem;

      const botBuilderId = nanoid();
      const bouquestItems: any[] = [];
      if (cartItem.product.productType && cartItem.product.productType.key === "Gift-Card") {
        this.processGiftCard(cartItem, bouquestItems, botBuilderId);
      } else {
        this.processProduct(cartItem, bouquestItems, botBuilderId);
        this.processDelivery(cartItem, bouquestItems, botBuilderId);
        this.processCard(cartItem, bouquestItems, botBuilderId);
        this.processVase(cartItem, bouquestItems, botBuilderId);
        this.processGreet(cartItem, bouquestItems, botBuilderId);
        this.processUpgrade(cartItem, bouquestItems, botBuilderId);
        this.processAddon(cartItem, bouquestItems, botBuilderId);
        this.processDonation(cartItem, bouquestItems, botBuilderId);
      }

      bouquest[id] = bouquestItems;
    },
    processProduct(cartItem: any, bouquestItems: any[], botBuilderId: string) {
      const {
        id,
        product,
        vase,
        addons,
        greet,
        upgrade,
        donations,
        contactDetails,
        recipient,
        deliveryWindow,
        card,
        cardMessages,
        cardSignature,
        cardMessagesWithSignature,
        subsDeliveryDates,
        weather,
        locale,
        deliveryTown,
        occasion,
        cutoffSessionStart
      } = cartItem;

      const lineItem: any = {
        id: product.id,
        title: product.title,
        groupID: id,
        productType: product.productType.key,
        variant: product,
        quantity: 1,
      };

      let _addons = addons ? Object.values(addons).map((addon: any) => {
        if (addon.quantity > 0) {
          return `${addon.title} (x${addon.quantity})`;
        } else {
          return addon.title;
        }
      }).join(",") : "";

      let _donations = donations ? Object.values(donations).map((donation: any) => {
        if (donation.quantity > 0) {
          return `${donation.title} (x${donation.quantity})`;
        } else {
          return donation.title;
        }
      }).join(",") : "";

      let textLang = contactDetails.textCommunicationLang === 'English' ? 'CA-en' : 'CA-fr';
      lineItem.customAttributes = [
        { key: CustomAttributs._COLLECTIONID, value: product.title },
        {
          key: CustomAttributs.DELIVERY_DATE,
          value: sessionStorage.curatedDeliveryDate
            ? dayjs(sessionStorage.curatedDeliveryDate).format("MM/DD/YYYY")
            : dayjs(deliveryWindow.deliveryDate).format("MM/DD/YYYY"),
        },
        { key: CustomAttributs._BOLDBUILDERID, value: botBuilderId },
        { key: CustomAttributs._VASE, value: vase.title || "" },
        { key: CustomAttributs._GREET, value: greet.title || "" },
        { key: CustomAttributs._UPGRADE, value: upgrade.title || "" },
        { key: CustomAttributs._ADDONS, value: _addons },
        { key: CustomAttributs._DONATION, value: _donations },
        { key: CustomAttributs.FIRST_NAME, value: recipient.firstName },
        { key: CustomAttributs.LAST_NAME, value: recipient.lastName },
        { key: CustomAttributs.ADDRESS, value: recipient.address },
        { key: CustomAttributs.CITY, value: recipient.city },
        {
          key: CustomAttributs.PROVINCE,
          value: recipient.province || "",
        },
        { key: CustomAttributs.POSTAL_CODE, value: recipient.postalCode },
        { key: CustomAttributs.UNIT_NUMBER, value: recipient.apartment ? recipient.apartment : "" },
        { key: CustomAttributs.ADDRESS_TYPE, value: recipient.addressType },
        { key: CustomAttributs.DELIVERY_NOTES, value: recipient.deliveryNote ? recipient.deliveryNote : "" },
        { key: CustomAttributs.BUZZER_CODE, value: recipient.buzzerCode ? recipient.buzzerCode : "" },
        { key: CustomAttributs._DELIVERY_CITY, value: deliveryTown.name   },
        { key: CustomAttributs._DELIVERY_REGION, value: deliveryWindow.deliveryRegion },
        { key: CustomAttributs._LATITUDE, value: recipient.latitude || "" },
        { key: CustomAttributs._LONGITUDE, value: recipient.longitude || "" },
        { key: CustomAttributs._DATADOG_SESSION_ID, value: this.getatadogSessionID() },
        { key: CustomAttributs.SHIPPING_METHOD, value: deliveryWindow.timeView },
        { key: CustomAttributs._SHIPPING_COST, value: deliveryWindow.price },
        { key: CustomAttributs._REGION, value: deliveryWindow.deliveryRegion },
        // TODO ID of shopify product variant. should be come from deliveryWindow
        { key: CustomAttributs._DELIVERY_METHOD, value: deliveryWindow.productVariant.id || '' },

        { key: CustomAttributs._CONSENT, value: contactDetails.toggleYes },
        { key: CustomAttributs.RECIPIENT_PHONE_NUMBER, value: contactDetails.phone },
        { key: CustomAttributs.CONTACT_NAME, value: contactDetails.name },
        { key: CustomAttributs._REGION_CODE, value: deliveryWindow.regionCode },
        { key: CustomAttributs._EMAIL_LANGUAGE, value: locale },
        { key: CustomAttributs._TEXTLANGUAGE, value: textLang },
        { key: CustomAttributs.CARD_TYPE, value: card.title },
        { key: CustomAttributs._OCCASION, value: occasion },
        { key: CustomAttributs._RELATIONSHIP, value: recipient.relationship },
        { key: CustomAttributs._CUTOFF_SESSION_START, value: cutoffSessionStart },

        { key: CustomAttributs._WEATHER, value: weather.weatherType },
        { key: CustomAttributs._TEMPERATURE, value: weather.temperature },
        // TODO add analytics
        { key: CustomAttributs._DIAGNOSTICS_SCREEN, value: "" },
        { key: CustomAttributs._DIAGNOSTICS_MOBILE, value: "" },
        { key: CustomAttributs._DIAGNOSTICS_OS, value: "" },
        { key: CustomAttributs._DIAGNOSTICS_BROWSER, value: "" },
        { key: CustomAttributs._DIAGNOSTICS_UA, value: "" },
        { key: CustomAttributs._WEBSITE, value: "" },
        // ------------------
        { key: CustomAttributs._WEBSITE_VERSION, value: "callia 2.0" },
        { key: CustomAttributs._FREQUENCY, value: product.selectedSellingPlan ? product.selectedSellingPlan.name : '' },
        { key: CustomAttributs.MSG_CARD_IMAGE, value: sessionStorage.messageCardImage ? sessionStorage.messageCardImage  : '' },
      ];

      if (JSON.stringify(subsDeliveryDates) !== "{}") {
        Object.keys(subsDeliveryDates).forEach((key) => {
          if (subsDeliveryDates[key] !== "") {
            lineItem.customAttributes.push({
              key: key.replace("DELIVERY_DATE", CustomAttributs.DELIVERY_DATE),
              value: dayjs(subsDeliveryDates[key]).format("MM/DD/YYYY"),
            });
          }
        });
      }

      if (cardMessages && JSON.stringify(cardMessages) !== "{}") {
        Object.keys(cardMessages).forEach((key) => {
          lineItem.customAttributes.push({key: key, value: cardMessagesWithSignature[key] ? cardMessagesWithSignature[key] : cardMessages[key],
          });
        });
      }
      if (cardSignature && cardSignature.trim().length > 0) {
        lineItem.customAttributes.push({key: `_Signature`, value: cardSignature});
      }

      bouquestItems.push(lineItem);
    },
    processVase(cartItem: any, bouquestItems: any[], botBuilderId: string) {
      const { id, vase } = cartItem;
      if (!vase.title) {
        return;
      }
      const lineItem: any = {
        id: vase.addon.id,
        title: vase.title,
        groupID: id,
        productType: vase.productType,
        variant: vase.addon.variant,
        quantity: vase.quantity,
      };

      lineItem.customAttributes = [
        { key: CustomAttributs._BOLDBUILDERID, value: botBuilderId },
      ];

      bouquestItems.push(lineItem);
    },
    processGreet(cartItem: any, bouquestItems: any[], botBuilderId: string) {
      const { id, greet } = cartItem;
      if (!greet.title) {
        return;
      }
      const lineItem: any = {
        id: greet.id,
        title: greet.title,
        groupID: id,
        productType: GIFT_ADDS,
        variant: greet.variant,
        quantity: 1
      };

      lineItem.customAttributes = [
        { key: CustomAttributs._BOLDBUILDERID, value: botBuilderId },
      ];

      bouquestItems.push(lineItem);
    },
    processUpgrade(cartItem: any, bouquestItems: any[], botBuilderId: string) {
      const { id, upgrade } = cartItem;
      if (!upgrade.title) {
        return;
      }
      const lineItem: any = {
        id: upgrade.id,
        title: upgrade.title,
        groupID: id,
        productType: GIFT_ADDS,
        variant: upgrade.variant,
        quantity: 1
      };

      lineItem.customAttributes = [
        { key: CustomAttributs._BOLDBUILDERID, value: botBuilderId },
      ];

      bouquestItems.push(lineItem);
    },
    processAddon(cartItem: any, bouquestItems: any[], botBuilderId: string) {
      const { id, addons } = cartItem;
      Object.values(addons).forEach((item: any) => {
        const lineItem: any = {
          id: item.addon.id,
          title: item.title,
          groupID: id,
          productType: item.productType,
          variant: item.addon.variant,
          quantity: item.quantity,
        };

        lineItem.customAttributes = [
          { key: CustomAttributs._BOLDBUILDERID, value: botBuilderId },
        ];

        bouquestItems.push(lineItem);
      });
    },
    processDonation(cartItem: any, bouquestItems: any[], botBuilderId: string) {
      const { id, donations } = cartItem;
      Object.values(donations).forEach((item: any) => {
        const lineItem: any = {
          id: item.addon.id,
          title: item.title,
          groupID: id,
          productType: item.productType,
          variant: item.addon.variant,
          quantity: item.quantity,
        };

        lineItem.customAttributes = [
          { key: CustomAttributs._BOLDBUILDERID, value: botBuilderId },
        ];

        bouquestItems.push(lineItem);
      });
    },
    processDelivery(cartItem: any, bouquestItems: any[], botBuilderId: string) {
      const { id, product, contactDetails, recipient, deliveryWindow } = cartItem;
      const lineItem: any = {
        id: deliveryWindow.productVariant.id,
        title: deliveryWindow.title,
        groupID: id,
        productType: DELIVERY,
        variant: deliveryWindow.productVariant,
        quantity: 1,
      };

      lineItem.customAttributes = [
        { key: CustomAttributs._BOLDBUILDERID, value: botBuilderId },
        { key: CustomAttributs.DELIVERY_TYPE, value: deliveryWindow.timeView },
        { key: CustomAttributs._REGION, value: deliveryWindow.deliveryRegion },
        { key: CustomAttributs._REGION_CODE, value: deliveryWindow.regionCode },
        { key: CustomAttributs._SHIPPING_COST, value: deliveryWindow.price },
        { key: CustomAttributs.RECIPIENT_PHONE_NUMBER, value: contactDetails.phone },
        { key: CustomAttributs.SKU, value: product.sku },
        { key: CustomAttributs.CONTACT_NAME, value: contactDetails.name },
        {
          key: CustomAttributs.DELIVERY_TO,
          value: `${recipient.firstName} ${recipient.lastName} ${recipient.address}, ${recipient.postalCode} ${recipient.deliveryNote}`,
        },
        { key: CustomAttributs._ITEM, value: `${product.parentProductTitle} (${product.title})` },
      ];
      //Non-floral CustomAttributs, start date won't needed cus it's sessionStorage.curatedDeliveryDate will be added in delivery-window.vue
      if (deliveryWindow.pullDate) {
        lineItem.customAttributes.push({ key: CustomAttributs._PULL_DATE, value: deliveryWindow.pullDate });
        lineItem.customAttributes.push({ key: CustomAttributs.END_DELIVERY_DATE, value: deliveryWindow.endDeliveryDate });
      }
      bouquestItems.push(lineItem);
    },
    processCard(cartItem: any, bouquestItems: any[], botBuilderId: string) {
      const { id, product, contactDetails, recipient, card } = cartItem;

      const lineItem: any = {
        id: card.productVariants[0].id,
        title: card.title,
        groupID: id,
        productType: CARD,
        variant: card.productVariant,
        quantity: 1,
      };

      lineItem.customAttributes = [{ key: CustomAttributs._BOLDBUILDERID, value: botBuilderId }];
      bouquestItems.push(lineItem);
    },
    processGiftCard(cartItem: any, bouquestItems: any[], botBuilderId: string) {
      const { id, product} = cartItem;

      const lineItem: any = {
        id: product.id,
        title: product.parentProductTitle,
        groupID: id,
        productType: product.productType.key,
        quantity: 1,
      };
      lineItem.customAttributes = [
        { key: CustomAttributs._COLLECTIONID, value: product.title },
        { key: CustomAttributs.SKU, value: product.sku },
        { key: CustomAttributs._BOLDBUILDERID, value: botBuilderId },
        {
          key: CustomAttributs._DATADOG_SESSION_ID,
          value: this.getatadogSessionID(),
        },
        // TODO-
        { key: CustomAttributs._DIAGNOSTICS_SCREEN, value: "" },
        { key: CustomAttributs._DIAGNOSTICS_MOBILE, value: "" },
        { key: CustomAttributs._DIAGNOSTICS_OS, value: "" },
        { key: CustomAttributs._DIAGNOSTICS_BROWSER, value: "" },
        { key: CustomAttributs._DIAGNOSTICS_UA, value: "" },
        { key: CustomAttributs._WEBSITE, value: "" },
        { key: CustomAttributs._WEBSITE_VERSION, value: "callia 2.0" },
      ];
      bouquestItems.push(lineItem);
    },
    getatadogSessionID() {
      let datadog_session_id = "";
      let dataDogCookie = getCookieValueByName("_dd_s");
      const result = dataDogCookie ? dataDogCookie.match(new RegExp('id=' + "(.*)" + '&created')) : [];
      if (result && result.length != 0) {
        datadog_session_id = result[1];
      }
      return datadog_session_id;
    },
  },
};
